<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="Datum" name="txtDatum" [Label]="'NEDELJNINETOOTKUPNIFOND.DATUM.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
        <span *ngFor="let validation of errorMessages.Datum">
          <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.Datum.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-dropdown-picklist
                    [ModelName]="'valuta'"
                    [GetName]="'getConvertible'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    formControlName="ValutaID"
                    [Label]="'NEDELJNINETOOTKUPNIFOND.VALUTANAZIV.SINGULAR'"
                    >
              </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
        <span *ngFor="let validation of errorMessages.ValutaID">
          <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.ValutaID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div> 
    
  <!-- <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist
                    [ModelName]="'valuta'"
                    [GetName]="'getConvertible'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="true"
                    formControlName="ValutaID"
                    [Label]="'NEDELJNINETOOTKUPNIFOND.VALUTANAZIV.SINGULAR'"
                    >
              </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
        <span *ngFor="let validation of errorMessages.ValutaID">
          <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.ValutaID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div> -->

  <div class="row mt-2">
      <div class="col-md-12">  
        <button type="button" class="btn btn-primary" (click)="LoadData()">
          Učitaj podatke
        </button>
      </div>
  </div>
</form>
<yt-fw-default-table
  *ngIf="modelData!=null && modelData.MainList!=null"
  [Config]="Config"
  [Items]="items"
  [TableColumns]="modelData.MainList.TableColumns"      
  [TableColumnsSums]="modelData.MainList.TableColumnsSums"
  [Condensed]="CondensedTable"
  [ShowLoader]="MainItemsLoading"
  (RefreshDataClicked)="RefreshData()"
>
</yt-fw-default-table>


